type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Called by DetailPanel once it has mounted with its record and measured its
 * box. Only the loaded panel renders that element, so this fires when the
 * details section is genuinely on screen -- not on a timer.
 */
export const notifyDetailPanelReady = () => {
  const pending = Array.from(listeners);
  listeners.clear();
  pending.forEach(listener => listener());
};

/**
 * Drops anything still waiting. Called when navigation leaves the page that
 * queued it: otherwise a request whose panel never mounted (a failed fetch, or
 * the user pressing Back mid-load) would fire against the next unrelated panel
 * and show its banner there.
 */
export const cancelPendingDetailPanelListeners = () => {
  listeners.clear();
};

/** Runs the listener the next time a detail panel mounts, then forgets it. */
export const onNextDetailPanelReady = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
